import React from 'react';
import PropTypes from 'prop-types';
import QUESTIONS from '../constants/configurations';

const LpHeader = ({ order }) => (
  <>
    <div className="lp-survey-step-padding">
      <strong className="text-center c-kale-500">
        Step {order} of {Object.keys(QUESTIONS).length}
      </strong>
    </div>
  </>
);

LpHeader.propTypes = {
  order: PropTypes.number.isRequired,
};

export default LpHeader;
